import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import i18n, { applyLangToDocument } from "./i18n";
import { initTelegram } from "./lib/telegram";
import { initTheme } from "./lib/theme";
import { App } from "./App";
import "./index.css";

initTelegram();
initTheme();
// Apply the initial language direction so Hebrew flips the layout from the
// very first paint. i18n initialises synchronously via the import above,
// then we subscribe to language changes to keep <html dir> in sync.
applyLangToDocument(i18n.language);
i18n.on("languageChanged", applyLangToDocument);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
